// extracted by mini-css-extract-plugin
module.exports = {"featured":"styles_featured__73HtX","highlight":"styles_highlight__YSyQz"};